import { useRecoilTransaction_UNSTABLE } from "recoil"

import type { TransactionOperation } from "."
import { areaIndex } from "../areas"
import { panelSelectionState } from "../panels"
import { areasOfPanelsIndexState } from "../relations"

export const selectPanelsInArea: TransactionOperation<string> = (
  transactors,
  id,
) => {
  const { get, set } = transactors
  const areasOfPanels = get(areasOfPanelsIndexState)
  const allAreaIds = get(areaIndex)
  const areaExists = allAreaIds.includes(id)
  if (areaExists) {
    const panelsToSelect = areasOfPanels.core.get(id)
    const panels = new Set(panelsToSelect)
    set(panelSelectionState, panels)
  }
}

export const useSelectPanelsInArea = (id: string): VoidFunction =>
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => selectPanelsInArea(transactors, id),
  )
